import type { IPlan } from "@proj-common/types"
import { StarterPlan } from "./pricing/plans/starter"
import { ProfessionalPlan } from "./pricing/plans/professional"
import { BusinessPlan } from "./pricing/plans/business"

export const Plans: IPlan[] = [
    StarterPlan,
    ProfessionalPlan,
    BusinessPlan,
]

export const GetPriceFor = (priceLookupKey: string, returnMonthly: boolean = true): number => {
    for (let i = 0; i < Plans.length; i++) {
        let plan = Plans[i]
        let price = plan.paddlePriceData.find(pd => pd.customData.lookup_key == priceLookupKey)
        if (price) {
            if (price.billingCycle.interval == "year" && returnMonthly) {
                return parseInt(price.unitPrice.amount) / 100 / 12
            } else {
                return parseInt(price.unitPrice.amount) / 100
            }
        }
    }
    return null
}